import BaseService from './baseService';

class Dashboard extends BaseService {
  async getSubmissionRecap(opts = {}) {
		this.endPoint = '/dashboard';
		return this.post(opts);
  }
  async getSubmissionRecaps(payload, opts = {}) {
		this.endPoint = '/submission/recap?filter=' + payload.filter;
		return this.get(opts);
  }
  async getFirstInvoice(opts = {}) {
    this.endPoint = 'invoices/get-first-invoice';
    return this.get(opts);
  }
  async approveFirstInvoice(opts = {}) {
    this.endPoint = 'invoices/approve-first-invoice';
    return this.post(opts);
  }
}

export default new Dashboard();